import React from 'react';
import { useTranslation } from 'react-i18next';
import logo5andarIW from '@panel/commons/assets/logos/logoIW_5A.svg';
import logo5andarWI from '@panel/commons/assets/logos/logoWI_5A.svg';
import { site } from '@panel/commons/helpers';
import {
  BannerContainer,
  BannerLogo,
  BannerTitle,
  BannerText,
  BannerBenefitsCheck,
  BannerBenefitsDetail,
  BannerButton
} from './styles';

const siteId = site.id;
const logo5andar = siteId === 'IWBR' ? logo5andarIW : logo5andarWI;

function BannerBrasil({ handleClick }) {
  const { t } = useTranslation();
  return (
    <BannerContainer>
      <BannerLogo>
        <img src={logo5andar} alt='' />
      </BannerLogo>
      <BannerTitle>{t('publisher.stepStatus.success.banner.title')}</BannerTitle>
      <>
        <BannerText>{t('publisher.stepStatus.success.banner.subtitle')}</BannerText>
        <div>
          <BannerBenefitsCheck />
          <BannerBenefitsDetail>{t('publisher.stepStatus.success.banner.benefits1')}</BannerBenefitsDetail>
        </div>
        <div>
          <BannerBenefitsCheck />
          <BannerBenefitsDetail>{t('publisher.stepStatus.success.banner.benefits2')}</BannerBenefitsDetail>
        </div>
        <div>
          <BannerBenefitsCheck />
          <BannerBenefitsDetail>{t('publisher.stepStatus.success.banner.benefits3')}</BannerBenefitsDetail>
        </div>
      </>
      <BannerButton type='button' onClick={handleClick}>
        {t('publisher.stepStatus.success.banner.button')}
      </BannerButton>
    </BannerContainer>
  );
}

export default BannerBrasil;
